var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"title":"Recreate","icon":"mdi-sync","loading":_vm.loading},on:{"click":function($event){return _vm.recreate()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }